export type RecurrenceFrequency = 'daily' | 'weekly' | 'biweekly' | 'monthly';

export interface RecurrenceSeries {
  id: string;
  property_id: string;
  employee_id: string;
  frequency: RecurrenceFrequency;
  interval: number;
  start_date: string;
  end_date?: string;
  occurrences_count?: number;
  days_of_week?: number[]; // 0=domingo, 1=segunda, ..., 6=sábado
  day_of_month?: number;
  scheduled_time: string; // HH:MM
  duration: number; // minutos
  price?: number;
  special_instructions?: string;
  reminder_minutes: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by?: string;
}

export interface RecurrenceException {
  id: string;
  recurrence_series_id: string;
  original_date: string;
  is_cancelled: boolean;
  rescheduled_appointment_id?: string;
  modified_scheduled_date?: string;
  modified_duration?: number;
  modified_price?: number;
  modified_special_instructions?: string;
  created_at: string;
  created_by?: string;
}

export interface RecurrenceSeriesResponse extends RecurrenceSeries {
  upcoming_occurrences: string[];
  total_occurrences: number;
  completed_count: number;
  cancelled_count: number;
}

export interface CreateRecurrenceSeriesRequest {
  property_id: string;
  employee_id: string;
  frequency: RecurrenceFrequency;
  interval: number;
  start_date: string;
  end_date?: string;
  occurrences_count?: number;
  days_of_week?: number[];
  day_of_month?: number;
  scheduled_time: string;
  duration: number;
  price?: number;
  special_instructions?: string;
  reminder_minutes: number;
}

export interface UpdateRecurrenceSeriesRequest {
  end_date?: string;
  occurrences_count?: number;
  duration?: number;
  price?: number;
  special_instructions?: string;
  reminder_minutes?: number;
  is_active?: boolean;
}

export interface UpdateSingleOccurrenceRequest {
  original_date: string;
  modified_scheduled_date?: string;
  modified_duration?: number;
  modified_price?: number;
  modified_special_instructions?: string;
}

export interface CancelOccurrenceRequest {
  cancel_all: boolean;
  original_date?: string;
  reason?: string;
}

export interface ConflictValidationResponse {
  has_conflicts: boolean;
  conflicts: string[];
  count: number;
}

export const WEEKDAY_LABELS: Record<number, string> = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado'
};

export const FREQUENCY_LABELS: Record<RecurrenceFrequency, string> = {
  daily: 'Diário',
  weekly: 'Semanal',
  biweekly: 'Quinzenal',
  monthly: 'Mensal'
};

